import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function PlusFiveCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    PlaySound('booster-five-cards-use');

    const targetCards: BaseCard[] = taskData.cards.map((targetCardID: string) =>
        system.getCardByID(targetCardID)
    );

    // Hide target cards initially.
    for (let card of targetCards) {
        card.getComponent(Renderable).visible = false;
    }

    const plusFiveAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(plusFiveAnimator);

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardPlusFive',
        plusFiveAnimator,
        {
            system,
            targetCards: targetCards,
            stackContainer: system.stackContainer,
        }
    );

    system.taskQueue.queue(task);
}
